<template>
  <div class="wrap">
    <div class="oq_count_formula mb5">
      <div class="oq_formula">
        <font>本单成本利润率 = </font>
        <div>
          <div class="oq_denominator">
            [{{ loadData.ext.saleTotal }}* (1-{{ loadData.ext.handfeeRate }}%)
            ]*{{ loadData.ext.currencyRate }} - {{ loadData.ext.cost }}
          </div>
          <div class="oq_numerator mt5">{{ loadData.ext.cost }}</div>
        </div>
        <div>* 100% = {{ loadData.ext.profit }}</div>
      </div>
    </div>
    <table class="normal">
      <tbody>
        <tr>
          <td>销售总计</td>
          <td>货款总计</td>
          <td>当前汇率</td>
          <td>手续费率(其他)</td>
        </tr>
        <tr>
          <td>
            {{ dictMap["currency_mark"][loadData.currency] }}
            {{ loadData.ext.saleTotal }}
          </td>
          <td>￥{{ loadData.ext.cost }}</td>
          <td>1：{{ loadData.ext.currencyRate }}</td>
          <td>{{ loadData.ext.handfeeRate }}%</td>
        </tr>
      </tbody>
    </table>
    <div class="oq_count_formula mt5">
      <div class="mb5 f14">计算公式：</div>
      <div class="mb5">成本利润率 = （利润/成本）* 100%</div>
      <div class="mb5">成本 = 货款总计</div>
      <div class="mb5">利润 = 营业收入 - 成本</div>
      <div class="mb5">营业收入 = （销售总计 - 手续费）* 汇率</div>
      <div>手续费 = 销售总计 * 手续费率</div>
    </div>
    
    <div class="mt10 mb10 tr" v-if="user.userType !== '00'">
      <span
        v-if="user.userType == '01'"
        class="blue cp underline ml15"
        @click="exchange"
      >
        汇率设置
      </span>
      <span
        v-if="user.userType == '01'"
        class="blue cp underline ml15"
        @click="service"
      >
        手续费设置
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  name: "LoanTip",
  data() {
    return {
      roles: [],
    }
  },
  props: {
    loadData: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    ...mapGetters(["user", "dictMap"]),
  },
  mounted() {
    this.roles = this.user.roles
  },
  methods: {
    exchange() {
      this.$emit("exchange")
    },
    service() {
      this.$emit("service")
    },
  },
}
</script>

<style scoped>
.wrap {
  font-size: 12px;
}
.mb5 {
  margin-bottom: 5px;
}
.mb10 {
  margin-bottom: 10px;
}
.mt5 {
  margin-top: 5px;
}
.mr15 {
  margin-right: 15px;
}
.ml15 {
  margin-left: 15px;
}
.mt10 {
  margin-top: 10px;
}
.underline {
  text-decoration: underline;
}
.blue {
  color: #1e7ec8;
}
.tr {
  text-align: right;
}
.cp {
  cursor: pointer;
}
.order-profit,
.order-qty {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  margin-top: -2px;
}
.profit-input {
  width: 80px;
  height: 28px;
  border: 1px solid rgb(225, 227, 229);
  padding: 0 5px;
  vertical-align: middle;
}
.oq_tip_box {
  padding: 10px;
  background: #fff;
  border: 1px solid #dfdfdf;
  border-radius: 5px;
  color: #333;
  text-align: left;
  font-size: 12px;
  font-weight: normal;
  cursor: auto;
  box-shadow: 2px 4px 5px rgba(0, 0, 0, 0.1);
}
.oq_formula {
  position: relative;
}
.oq_formula span {
  display: inline-block;
  width: 180px;
  height: 1px;
  background: #111111;
  margin-bottom: 4px;
}
.oq_formula > div {
  line-height: 1.4;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  margin-left: 5px;
}
.oq_denominator {
  padding: 0 5px 5px;
  border-bottom: 1px solid #111;
}
.oq_count_formula {
  padding: 10px;
  border: 1px solid rgb(221, 221, 221);
}
.normal {
  border: 1px solid rgb(221, 221, 221);
  width: 100%;
  padding: 10px;
}
.normal.order tbody tr {
  background-color: rgb(255, 255, 255);
}
.normal.order tbody tr.order {
  background-color: rgb(245, 247, 250);
}
.normal.order tbody tr:hover {
  background-color: rgba(242, 242, 242, 0.6);
}
.exchange-table {
  overflow-y: auto;
  max-height: 360px;
  font-size: 12px;
}
.exchangeDialog {
  z-index: 999;
}
</style>
